import type { SectionDetailLecturesItem } from './sectionDetailLecturesItem';

export interface SectionDetail {
  id: number;
  lectures: SectionDetailLecturesItem[];
  title: string;
}
